import { render, staticRenderFns } from "./bonusfrm.vue?vue&type=template&id=580508ec"
import script from "./bonusfrm.vue?vue&type=script&lang=js"
export * from "./bonusfrm.vue?vue&type=script&lang=js"
import style0 from "./bonusfrm.vue?vue&type=style&index=0&id=580508ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports